import React from 'react';

export const CheckoutModalContext = React.createContext({
  open: {},
  openModal: () => {},
});
